import React from 'react';
import ToolbarLinks from './HeaderToolbar/ToolbarLinks.jsx';
import {
  makeStyles,
  Toolbar,
  IconButton,
  Icon,
  Hidden
} from '@material-ui/core';
import { Link } from 'react-router-dom';

const HeaderToolbar = ({ toggleDrawer }) => {

  const useStyles = makeStyles(theme => ({
    navStyle: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    menuStyle: {
      display: 'flex',
      justifyContent: 'center',
      color: '#000'
    },
    logoStyle: {
      width: 100
    }
  }))

  const classes = useStyles();

  return (
    <Toolbar className={classes.navStyle} component="nav">
      <Link to="/home">
      <img className={classes.logoStyle} src="/img/logo.png" alt="logo" />
      </Link>
      <Hidden mdUp>
        <IconButton className={classes.menuStyle} onClick={toggleDrawer}><Icon>menu</Icon></IconButton>
      </Hidden>
      <Hidden smDown>
        <ToolbarLinks />
      </Hidden>
    </Toolbar>
  )
}

export default HeaderToolbar;